import React, { useEffect } from 'react'

const s = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(15, 23, 42, 0.8)',
    backdropFilter: 'blur(4px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    overflowY: 'auto'
  },
  modal: {
    backgroundColor: '#1e293b',
    borderRadius: '12px',
    padding: '32px',
    border: '1px solid #334155',
    maxWidth: '400px',
    width: '90%',
    textAlign: 'center',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)'
  },
  icon: {
    fontSize: '48px',
    marginBottom: '16px'
  },
  title: {
    fontSize: '24px',
    fontWeight: '600',
    margin: '0 0 12px 0',
    color: '#f1f5f9'
  },
  feature: {
    fontSize: '18px',
    fontWeight: '500',
    margin: '0 0 16px 0',
    color: '#2563eb'
  },
  message: {
    fontSize: '16px',
    color: '#94a3b8',
    margin: '0 0 24px 0',
    lineHeight: '1.5'
  },
  btnPrimary: {
    padding: '12px 24px',
    backgroundColor: '#2563eb',
    color: 'white',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: '600',
    marginRight: '12px'
  },
  btnSecondary: {
    backgroundColor: 'transparent',
    border: '1px solid #475569',
    color: '#94a3b8',
    fontSize: '14px',
    cursor: 'pointer',
    padding: '8px 16px',
    borderRadius: '6px'
  }
}

// `hadTrial` mirrors PreviewWall: a user who has already used their trial must
// not be offered another. This overlay is the GLOBAL fallback (profile,
// calculators, affiliates, tracker...), so the hardcoded trial copy showed up
// on every page that is not a tool page.
export default function PreviewOverlay({ featureName, onGotoPricing, onClose, hadTrial = false }) {
  const trial = !hadTrial
  // Prevent body scrolling when overlay is shown
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  const handleUpgrade = () => {
    onGotoPricing()
  }

  const handleOverlayClick = (e) => {
    // Close if clicking on the overlay background (not the modal)
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <div style={s.overlay} onClick={handleOverlayClick}>
      <div style={s.modal}>
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '12px' }}>
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        </svg>
        <h2 style={s.title}>Unlock {featureName}</h2>
        <p style={s.message}>
          {trial
            ? 'Start your free trial to unlock all the tools you need to beat the bookmaker at their own game!'
            : 'Upgrade to unlock all the tools you need to beat the bookmaker at their own game!'}
        </p>
        <div style={{ display: 'inline-flex', flexDirection: 'column', gap: '6px', alignItems: 'flex-start', marginBottom: '20px', textAlign: 'left' }}>
          {['Real time odds from all major bookmakers', 'Automatic stake calculation', 'Set your own custom filters', 'Much more...'].map(item => (
            <div key={item} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: '#cbd5e1' }}>
              <span style={{ color: '#34d399', fontWeight: '700' }}>✓</span> {item}
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
          <button style={{ ...s.btnPrimary, background: 'linear-gradient(135deg, #2563eb 0%, #1e40af 100%)', boxShadow: '0 4px 14px rgba(37, 99, 235, 0.5)' }} onClick={handleUpgrade}>
            {trial ? 'Start Your Free Trial' : 'Upgrade Now'}
          </button>
          <p style={{ fontSize: '12px', color: '#64748b', margin: 0 }}>
            {trial ? '7 Days free · Cancel anytime' : 'Cancel anytime'}
          </p>
          <button style={s.btnSecondary} onClick={onClose}>
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  )
}